import {makeAutoObservable} from "mobx";
import FileService from "../service/FileService";

export class FileStore {
    constructor() {
        this.files = [];
        this.currentInfo = null;
        this.currentFile = null;
        this.isInit = false;
        makeAutoObservable(this);
    }

    setIsInit(isInit) {
        this.isInit = isInit;
    }

    setFiles(files) {
        this.files = files;
    }

    setCurrentInfo(info) {
        this.currentInfo = info;
    }

    setCurrentFile(id) {
        this.currentFile = id;
    }

    async upload(file, userID) {
        if (!file) {
            alert("Выберите файл")
            return
        }
        try {
            await FileService.uploadFile(userID, file)
        } catch (err) {
            alert(`Ошибка при загрузке: ${err.response.data.message}`)
        }
    }

    async getFiles(userID) {
        this.setIsInit(false);
        try {
            const res = await FileService.getUserFiles(userID);
            this.setFiles(res.data);
            return res;
        } finally {
            this.setIsInit(true);
        }
    }

    async deleteFile(userID, num) { // num - номер файла в списке, а не в бд
        const files = await this.getFiles(userID);
        await FileService.deleteFile(userID, files.data[num - 1].id)
    }
}